module.exports = __webpack_public_path__ + "static/media/Motivo4.8b694e47.png";